import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=21d7e14d&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=js&"
export * from "./statistics.vue?vue&type=script&lang=js&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=21d7e14d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7e14d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d7e14d')) {
      api.createRecord('21d7e14d', component.options)
    } else {
      api.reload('21d7e14d', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=21d7e14d&scoped=true&", function () {
      api.rerender('21d7e14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/statistics.vue"
export default component.exports